import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

interface Params {
  clientId: number;
  inviteId: string;
}

const resendInvite = async ({ clientId, inviteId }: Params): Promise<null> => {
  return authFetch(
    urlWithParams('/BeFi20/survey/ResendInvite', { clientId, alignment: inviteId }),
    {
      method: 'POST',
    },
  );
};

export const useResendInviteMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId();

  return useMutation(resendInvite, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.overview(clientId));
    },
  });
};
